// extracted by mini-css-extract-plugin
export default {"content":"success_content__ULL8y","pay":"success_pay__5-4lA"};